/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCurrentUserPylonUnreadBaselineRequest
 */
export interface UpdateCurrentUserPylonUnreadBaselineRequest {
    /**
     * Pylon unread-message count to treat as already acknowledged
     * @type {number}
     * @memberof UpdateCurrentUserPylonUnreadBaselineRequest
     */
    pylon_unread_baseline: number;
}

/**
 * Check if a given object implements the UpdateCurrentUserPylonUnreadBaselineRequest interface.
 */
export function instanceOfUpdateCurrentUserPylonUnreadBaselineRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pylon_unread_baseline" in value;

    return isInstance;
}

export function UpdateCurrentUserPylonUnreadBaselineRequestFromJSON(json: any): UpdateCurrentUserPylonUnreadBaselineRequest {
    return UpdateCurrentUserPylonUnreadBaselineRequestFromJSONTyped(json, false);
}

export function UpdateCurrentUserPylonUnreadBaselineRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCurrentUserPylonUnreadBaselineRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pylon_unread_baseline': json['pylon_unread_baseline'],
    };
}

export function UpdateCurrentUserPylonUnreadBaselineRequestToJSON(value?: UpdateCurrentUserPylonUnreadBaselineRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pylon_unread_baseline': value.pylon_unread_baseline,
    };
}

